import styled from 'styled-components';

export const Wrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: rgba(34, 66, 81, 0.5);
  border-radius: 50%;
  border: none;
  overflow: visible;
  -webkit-appearance: none;
  cursor: pointer;

  svg {
    width: 10px;
    fill: ${props => props.theme.card.background};
  }
`;
